/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Importing icons for edit and delete actions
import edit_logo from "../../../../icons/edit.svg";
import tash_logo from "../../../../icons/trash.svg";

// Row component to display individual data entries in the table
export default function Tr({
  id, // Unique identifier for the layer
  layer_class_name, // Name of the layer to be displayed
  onEdit, // Function to handle the edit action
  onDelete, // Function to handle the delete action
  isAllowedToEditOrDelete, // Boolean to determine if edit/delete options are available
}) {
  return (
    <>
      <tr>
        <td>{layer_class_name}</td> {/* Displaying the name of the layer */}
        <td>
          {/* Edit action link */}
          <a
            onClick={(e) => {
              // Check if editing is allowed
              isAllowedToEditOrDelete
                ? onEdit({
                    id, // Pass the ID and layer name for editing
                    layer_class_name,
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permissions
            }}
          >
            <img src={edit_logo} alt="Edit" /> {/* Edit icon */}
          </a>
          &nbsp; {/* Space between icons */}
          {/* Delete action link */}
          <a
            onClick={(e) => {
              // Check if deletion is allowed
              isAllowedToEditOrDelete
                ? onDelete({
                    id, // Pass the ID and layer name for deletion
                    layer_class_name,
                    delete: true,
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permissions
            }}
          >
            <img src={tash_logo} alt="Delete" /> {/* Delete icon */}
          </a>
          &nbsp; {/* Space between icons */}
        </td>
      </tr>
    </>
  );
}
